import { configureStore } from "@reduxjs/toolkit";
import  ec2Slicer  from "../features/ec2DetailSlicer";


export const store = configureStore({
  reducer: {
    ec2App: ec2Slicer
   },
  
});